module.exports = __webpack_public_path__ + "img/tlf_sum.dad87a99.png";